import { ENTITY } from "../common";

// Eligible Jurisdictions Notice.
// Owner-directed (2026-10-09): eligible jurisdictions = every U.S. state that is
// NOT on the excluded list. The excluded list is the authoritative geo-block
// configuration that actually gates access: backend/server.py BANNED_STATES
// (drives GET /geo/check). Keep this page in sync with that config.
export const EXCLUDED_STATES = [
  "Arizona", "Connecticut", "Idaho", "Louisiana", "Maryland",
  "Michigan", "Montana", "Nevada", "New Jersey", "New York",
];

const ALL_US = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
  "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois",
  "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
  "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
  "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
  "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
  "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
  "West Virginia", "Wisconsin", "Wyoming",
];

export const ELIGIBLE_STATES = ALL_US.filter((s) => !EXCLUDED_STATES.includes(s));

const eligibleJurisdictions = {
  slug: "eligible-jurisdictions",
  path: "/eligible-jurisdictions",
  title: "Eligible Jurisdictions Notice",
  shortTitle: "Eligible Jurisdictions",
  category: "Eligibility",
  sourceDoc: "Derived from live geo-block configuration (owner-approved rule)",
  status: "adopted",
  effectiveDate: "September 12, 2026",
  summary: "Where PrymeBet's promotional PCash sweepstakes is available, and the U.S. states where it is not.",
  flowTags: ["registration"],
  intro: [
    { type: "p", text: `This Notice states the U.S. jurisdictions where ${ENTITY} currently makes the promotional PCash sweepstakes available. You must both reside in and be physically located in an eligible jurisdiction for the relevant product. Both residence and physical location may be checked, and access from an excluded jurisdiction is blocked.` },
    { type: "note", text: "Eligibility for free PCoins entertainment play does not by itself establish eligibility for PCash sports, casino, or live-dealer participation. We may update this Notice to comply with applicable law; the controlling restriction is the operator's current location-verification configuration." },
  ],
  sections: [
    { id: "1", title: "Excluded U.S. states", blocks: [
      { type: "p", text: "The promotional PCash sweepstakes is **not** available to residents of, or persons physically located in, the following U.S. states:" },
      { type: "ul", items: EXCLUDED_STATES.map((s) => `**${s}**`) },
      { type: "p", text: "Using a VPN, proxy, or false location or residency information to access the sweepstakes from an excluded state is prohibited and may result in account closure and forfeiture of affected prizes." },
    ]},
    { id: "2", title: "Eligible U.S. jurisdictions", blocks: [
      { type: "p", text: "Subject to age and the other requirements in the [Terms of Service](/terms) and [PCash Sweepstakes Official Rules](/sweeps-rules), the promotional PCash sweepstakes is available to eligible participants who reside in and are physically located in any U.S. state or the District of Columbia **other than** the excluded states listed above — namely:" },
      { type: "ul", items: ELIGIBLE_STATES.map((s) => s) },
    ]},
    { id: "3", title: "How eligibility is applied", blocks: [
      { type: "p", text: "You must be at least 18 or the age of majority in your jurisdiction, whichever is greater. Account creation alone is not approval; residence, physical location, age, and identity are independently verified. If you travel into an excluded state, access to the sweepstakes may be blocked while you are located there. Free PCoins entertainment play and the ability to contact Support, make a privacy request, or pursue a lawful existing prize are handled separately." },
    ]},
  ],
};
export default eligibleJurisdictions;
